import React from "react";

/**
 * Muestra un importe del historial por mes usando totales por moneda reales.
 * Si hay varias monedas en el mes → una línea por moneda (S/, $, etc.).
 * Si no hay movimientos → usa el total estimado en summaryCurrency (fallback).
 *
 * @param {"income"|"totalCommitted"|"savings"|"finalRemaining"} field
 */
const EPS = 1e-6;

const MonthHistoryAmountColumn = ({ month, field, formatAmount, fallbackCurrency = "PEN", className = "" }) => {
  const tbc = month.totalsByCurrency || {};
  let codes = Object.keys(tbc).sort();

  // Ahorro: solo monedas donde hubo aporte real a metas (evita líneas en $ por gastos/ingresos USD sin ahorro en esa moneda)
  if (field === "savings") {
    codes = codes.filter((c) => Math.abs(tbc[c]?.savings ?? 0) > EPS);
    if (codes.length === 0 && Object.keys(tbc).length > 0) {
      return <span className={`${className} text-gray-400 dark:text-gray-500`}>—</span>;
    }
  }

  const legacy = {
    income: month.ingresos,
    totalCommitted: month.gastos,
    savings: month.ahorro,
    finalRemaining: month.restante
  };

  if (codes.length === 0) {
    return (
      <span className={className}>
        {formatAmount(legacy[field] ?? 0, false, month.summaryCurrency || fallbackCurrency)}
      </span>
    );
  }

  if (codes.length === 1) {
    const c = codes[0];
    return <span className={className}>{formatAmount(tbc[c][field] ?? 0, false, c)}</span>;
  }

  return (
    <div className={`flex flex-col gap-0.5 text-xs leading-tight ${className}`}>
      {codes.map((c) => (
        <span key={c}>{formatAmount(tbc[c][field] ?? 0, false, c)}</span>
      ))}
    </div>
  );
};

export default MonthHistoryAmountColumn;
